import { createFileRoute } from "@tanstack/react-router";
import { PlaybookOverview } from "../../../components/playbooks/playbook-overview";

/** The Overview (Paper PO1): where a playbook opens from the Playbooks list, a teammate or a chat. */
export const Route = createFileRoute("/_authenticated/_workspace/playbooks/$playbookId/")({
  component: function PlaybookOverviewRoute() {
    const { playbookId } = Route.useParams();
    return <PlaybookOverview playbookId={playbookId} />;
  },
});
